module.exports = __webpack_public_path__ + "img/one.aad5ca22.png";